import { FC, useMemo } from 'react';
import styled, { css } from "styled-components";
import { Avatar, FInter, FlexBox, useIsMobile } from "@brg/ui";
import { AuthorT } from './types';
import { LayoutConst } from 'core';
import { computeDesigner } from 'shared/helpers/computeData';
import { useTranslation } from 'react-i18next';
import { BasketIcon } from './BasketIcon';
import { useRouteMatch } from 'react-router-dom';

const CloseIcon: FC<{ onClick: () => void }> = ({ onClick }) => (
  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={onClick}>
    <path d="M4.99995 5.55234L1.65352 8.89877C1.51869 9.0336 1.29901 9.03437 1.16645 8.89732C1.13675 8.86661 1.1201 8.84878 1.11015 8.83771C0.980372 8.69332 0.970187 8.47732 1.10746 8.34004L4.44755 4.99995L1.10112 1.65351C0.966293 1.51869 0.966293 1.30009 1.10112 1.16526L1.16526 1.10112C1.30009 0.966293 1.51869 0.966293 1.65351 1.10112L4.99995 4.44755L8.34638 1.10112C8.48121 0.966293 8.69981 0.966294 8.83464 1.10112L8.89878 1.16526C9.0336 1.30009 9.0336 1.51869 8.89878 1.65351L5.55234 4.99995L8.89877 8.34638C9.0336 8.48121 9.03437 8.70089 8.89732 8.83345C8.86661 8.86315 8.84878 8.8798 8.83771 8.88975C8.69332 9.01953 8.47732 9.02971 8.34004 8.89243L4.99995 5.55234Z" fill="#909090" stroke="#909090" strokeWidth="0.4" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)


export type AuthorActionsT = {
  action: string,
  removedValue: AuthorT
}
type PropsT = {
  authors: AuthorT[];
  editing: boolean;
  onAddClick: () => void;
  onRemoveClick: (data: AuthorT[], { action, removedValue } : AuthorActionsT) => void;
  isProjectEdit?: boolean;
  isAdminPage?: boolean;
  isTeamMembers?: boolean;
  isPresentation?: boolean;
  flexible?: boolean;
  canRemoveUser?: boolean;
};

const DesignersWrapper = styled(FlexBox)<{ isBookEditPage?: boolean }>`
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  white-space: break-spaces;

  @media (max-width: ${LayoutConst.screen.s}px) {
    padding-top: 0;
  }

  // @media (max-width: ${LayoutConst.screen.md}px) {
  //   width: 100%;
  //   *:not(.icon-wrapper) {
  //     margin-left: 0 !important;
  //   }
  // }
`

const DesignerName = styled(FInter.SmallTextDiv)`
  font-size: 18px;
  line-height: 32px;
  color: ${({ theme }) => theme.projectView.titleColor};
  align-items: center;
  display: inline-block;

  // @media (max-width: ${LayoutConst.screen.m}px) {
  //   font-size: 13px;
  //   line-height: 18px;
  //   height: 44px;
  //   width: 100%;
  // }
`

export const DesignerNameMob = styled(FlexBox)<{ isProjectEdit?: boolean, isTeamEdit?: boolean, flexible?: boolean }>`
  align-items: center;
  display: flex;
  flex-flow: row;
  height: ${({ isTeamEdit, flexible}) => isTeamEdit || flexible ? '32px' : '36px'};;
  width: ${({ isTeamEdit, flexible}) => isTeamEdit || flexible ? 'auto' : '100%'};
  
  min-width: ${({ isTeamEdit, flexible}) => isTeamEdit || flexible ? 'auto' : '300px'};

  ${({ isTeamEdit, flexible}) => (isTeamEdit || flexible )? css`
    margin-right: 16px;
  ` : null};
    
  margin-bottom: ${({ isProjectEdit }) => isProjectEdit ? 0 : '12px'};

  svg {
    cursor: pointer;
  }

  @media(max-width: ${LayoutConst.screen.mac13}px) {
    height: 32px;
  }

  ${({ isProjectEdit }) => isProjectEdit ? css`
    
  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    max-width: 293px;
    min-width: 293px;
  }
    @media(max-width: 680px) {
      min-width: 269px;
    }
  ` : null};
`;

export const DesignerBorder = styled(FlexBox)<{ isTeamEdit?: boolean, isProjectEdit?: boolean, isAdminPage?: boolean }>`
  align-items: center;
  background: ${({ theme }) => theme.projectEdit.mobile.items.bg};
  border-radius: 5px;
  font-family: 'Inter';
  border: 1px solid ${({ theme }) => theme.projectEdit.mobile.buttons.border};
  font-size: ${({ isAdminPage }) => isAdminPage ? '13px' : '17px'};
  padding: ${({ isAdminPage }) => isAdminPage ? '5px 16px' : '6px 16px'};
  font-weight: 400;
  white-space: nowrap;
  line-height: ${({ isAdminPage }) => isAdminPage ? '16px' : '22px'};
  // color: ${({ theme }) => theme.projectEdit.mobile.inputs.color};
  color: ${({ theme }) => theme.tags.modal.simpleTag.color};
  margin-right: 8px;

  .text-wrapper {
    display: inline-block;
  }

  ${({ isProjectEdit }) => isProjectEdit ? css`
      font-size: 15px;
  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    .text-wrapper {
      overflow-x: hidden;
      text-overflow: ellipsis;
      max-width: 200px;
  }
      @media(max-width: ${LayoutConst.screen.l}px) {
        font-size: 13px;
      }
    }
  }
  ` : null}


  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 13px;
    line-height: 16px;
    place-items: center;
  
  ${({ isTeamEdit }) => isTeamEdit ? null : css`
    // div:first-child {
    //   width: 20px;
    //   height: 20px;
    // }
    .text-wrapper {
      overflow-x: hidden;
      text-overflow: ellipsis;
      max-width: 200px;
    }
  `};
  }

  @media(max-width: ${LayoutConst.screen.md}px) {
    .text-wrapper {
      max-width: none;
    }
  }

  @media(max-width: ${LayoutConst.screen.s}px) {
    max-width: 240px;
  }

  @media(max-width: ${LayoutConst.screen.sm}px) {
    max-width: none;
  }

  @media(max-width: ${LayoutConst.screen.xsm}px) {
    max-width: 270px;
  }
`;

const ProjectAuthorsDisplay: FC<PropsT> = ({
  authors,
  editing,
  onAddClick,
  onRemoveClick,
  canRemoveUser,
  isProjectEdit,
  isAdminPage,
  isTeamMembers,
  isPresentation,
  flexible,
}) => {
  const isMobile = useIsMobile();
  const { t } = useTranslation();
  const isBookEditPage = !!useRouteMatch("/books/edit");

  const handleRemove = (data: AuthorT[], { action, removedValue } : AuthorActionsT) => {
    const confirmation = window.confirm(t('confirmation.user_delete'));

    if (!confirmation) return;

    const authors = data?.filter((author) => author?.designerId !== removedValue?.designerId)
    onRemoveClick && onRemoveClick(authors, { action, removedValue });
  }

  const showRemoveControl = canRemoveUser !== false;

  const designersList = useMemo(
    () => ((authors || []).map((author, index, arr) => {
      const computeAuthor = computeDesigner(author);
        return (
          <DesignerNameMob key={computeAuthor.designerId} widthMobile={'100%'} isProjectEdit={isProjectEdit} flexible={flexible}>
            {(isAdminPage || isPresentation) ? (
              <DesignerBorder isProjectEdit={isProjectEdit} isAdminPage={isAdminPage} align={"center"}>
                <FlexBox style={{ borderRadius: '1.5px'}} width={24} height={24} widthMobile={24} heightMobile={24} offsetRightMobile={8} offsetRight={8}>
                  <Avatar avatar={computeAuthor?.avatar} fs={24} rounded />
                </FlexBox>
                <FlexBox className={'text-wrapper'} align="center" justifyMobile='space-between' /*widthMobile={'calc(100% - 56px)'}*/ alignMobile={'center'}>
                  {`${computeAuthor.name} ${isTeamMembers ? computeAuthor.middleName : ''} ${computeAuthor.surName}`}
                </FlexBox>
                <FlexBox style={{ display: showRemoveControl ? 'flex' : 'none'}} className={'icon-wrapper'} offsetLeft={8} offsetLeftMobile={8} align='center' alignMobile='center'>
                  {!!handleRemove && <CloseIcon onClick={() => handleRemove( arr, { action: 'remove-value', removedValue: author })}/>}
                </FlexBox>
              </DesignerBorder>
            ) : (
              <>
                <DesignerBorder isProjectEdit={isProjectEdit}>
                  <FlexBox style={{ borderRadius: '1.5px'}} width={24} height={24} widthMobile={24} heightMobile={24} offsetRightMobile={8} offsetRight={8}>
                    <Avatar avatar={computeAuthor?.avatar} fs={24} rounded />
                  </FlexBox>
                  <FlexBox className={'text-wrapper'} justifyMobile='space-between' /*widthMobile={'calc(100% - 56px)'}*/ alignMobile={'center'}>
                    {`${computeAuthor.name} ${isTeamMembers ? computeAuthor.middleName : ''} ${computeAuthor.surName}`}
                  </FlexBox>

                <FlexBox offsetLeft={8}>
                {!!handleRemove && <BasketIcon fill={'#909090'} onClick={() => handleRemove( arr, { action: 'remove-value', removedValue: author })}/>}
                </FlexBox>
                </DesignerBorder>
                
              </>
            )}
          </DesignerNameMob>

        )
  })),
    [authors, isMobile, handleRemove, showRemoveControl],
  );

  return (
    <DesignersWrapper isBookEditPage={isBookEditPage}>
      {designersList}
    </DesignersWrapper>
  );
};

export default ProjectAuthorsDisplay;
import { FC, useMemo } from 'react';
import styled, { css } from "styled-components";
import { Avatar, FInter, FlexBox, useIsMobile } from "@brg/ui";
import { AuthorT } from './types';
import { LayoutConst } from 'core';
import { computeDesigner } from 'shared/helpers/computeData';
import { useTranslation } from 'react-i18next';
import { BasketIcon } from './BasketIcon';
import { useRouteMatch } from 'react-router-dom';

const CloseIcon: FC<{ onClick: () => void }> = ({ onClick }) => (
  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={onClick}>
    <path d="M4.99995 5.55234L1.65352 8.89877C1.51869 9.0336 1.29901 9.03437 1.16645 8.89732C1.13675 8.86661 1.1201 8.84878 1.11015 8.83771C0.980372 8.69332 0.970187 8.47732 1.10746 8.34004L4.44755 4.99995L1.10112 1.65351C0.966293 1.51869 0.966293 1.30009 1.10112 1.16526L1.16526 1.10112C1.30009 0.966293 1.51869 0.966293 1.65351 1.10112L4.99995 4.44755L8.34638 1.10112C8.48121 0.966293 8.69981 0.966294 8.83464 1.10112L8.89878 1.16526C9.0336 1.30009 9.0336 1.51869 8.89878 1.65351L5.55234 4.99995L8.89877 8.34638C9.0336 8.48121 9.03437 8.70089 8.89732 8.83345C8.86661 8.86315 8.84878 8.8798 8.83771 8.88975C8.69332 9.01953 8.47732 9.02971 8.34004 8.89243L4.99995 5.55234Z" fill="#909090" stroke="#909090" strokeWidth="0.4" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)


export type AuthorActionsT = {
  action: string,
  removedValue: AuthorT
}
type PropsT = {
  authors: AuthorT[];
  editing: boolean;
  onAddClick: () => void;
  onRemoveClick: (data: AuthorT[], { action, removedValue } : AuthorActionsT) => void;
  isProjectEdit?: boolean;
  isAdminPage?: boolean;
  isTeamMembers?: boolean;
  isPresentation?: boolean;
  flexible?: boolean;
  canRemoveUser?: boolean;
};

const DesignersWrapper = styled(FlexBox)<{ isBookEditPage?: boolean }>`
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  white-space: break-spaces;

  @media (max-width: ${LayoutConst.screen.s}px) {
    padding-top: 0;
  }

  // @media (max-width: ${LayoutConst.screen.md}px) {
  //   width: 100%;
  //   *:not(.icon-wrapper) {
  //     margin-left: 0 !important;
  //   }
  // }
`

const DesignerName = styled(FInter.SmallTextDiv)`
  font-size: 18px;
  line-height: 32px;
  color: ${({ theme }) => theme.projectView.titleColor};
  align-items: center;
  display: inline-block;

  // @media (max-width: ${LayoutConst.screen.m}px) {
  //   font-size: 13px;
  //   line-height: 18px;
  //   height: 44px;
  //   width: 100%;
  // }
`

export const DesignerNameMob = styled(FlexBox)<{ isProjectEdit?: boolean, isTeamEdit?: boolean, flexible?: boolean }>`
  align-items: center;
  display: flex;
  flex-flow: row;
  height: ${({ isTeamEdit, flexible}) => isTeamEdit || flexible ? '32px' : '36px'};;
  width: ${({ isTeamEdit, flexible}) => isTeamEdit || flexible ? 'auto' : '100%'};
  
  min-width: ${({ isTeamEdit, flexible}) => isTeamEdit || flexible ? 'auto' : '300px'};

  ${({ isTeamEdit, flexible}) => (isTeamEdit || flexible )? css`
    margin-right: 16px;
  ` : null};
    
  margin-bottom: ${({ isProjectEdit }) => isProjectEdit ? 0 : '12px'};

  svg {
    cursor: pointer;
  }

  @media(max-width: ${LayoutConst.screen.mac13}px) {
    height: 32px;
  }

  ${({ isProjectEdit }) => isProjectEdit ? css`
    
  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    max-width: 293px;
    min-width: 293px;
  }
    @media(max-width: 680px) {
      min-width: 269px;
    }
  ` : null};
`;

export const DesignerBorder = styled(FlexBox)<{ isTeamEdit?: boolean, isProjectEdit?: boolean, isAdminPage?: boolean }>`
  align-items: center;
  background: ${({ theme }) => theme.projectEdit.mobile.items.bg};
  border-radius: 5px;
  font-family: 'Inter';
  border: 1px solid ${({ theme }) => theme.projectEdit.mobile.buttons.border};
  font-size: ${({ isAdminPage }) => isAdminPage ? '13px' : '17px'};
  padding: ${({ isAdminPage }) => isAdminPage ? '5px 16px' : '6px 16px'};
  font-weight: 400;
  white-space: nowrap;
  line-height: ${({ isAdminPage }) => isAdminPage ? '16px' : '22px'};
  // color: ${({ theme }) => theme.projectEdit.mobile.inputs.color};
  color: ${({ theme }) => theme.tags.modal.simpleTag.color};
  margin-right: 8px;

  .text-wrapper {
    display: inline-block;
  }

  ${({ isProjectEdit }) => isProjectEdit ? css`
      font-size: 15px;
  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    .text-wrapper {
      overflow-x: hidden;
      text-overflow: ellipsis;
      max-width: 200px;
  }
      @media(max-width: ${LayoutConst.screen.l}px) {
        font-size: 13px;
      }
    }
  }
  ` : null}


  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 13px;
    line-height: 16px;
    place-items: center;
  
  ${({ isTeamEdit }) => isTeamEdit ? null : css`
    // div:first-child {
    //   width: 20px;
    //   height: 20px;
    // }
    .text-wrapper {
      overflow-x: hidden;
      text-overflow: ellipsis;
      max-width: 200px;
    }
  `};
  }

  @media(max-width: ${LayoutConst.screen.md}px) {
    .text-wrapper {
      max-width: none;
    }
  }

  @media(max-width: ${LayoutConst.screen.s}px) {
    max-width: 240px;
  }

  @media(max-width: ${LayoutConst.screen.sm}px) {
    max-width: none;
  }

  @media(max-width: ${LayoutConst.screen.xsm}px) {
    max-width: 270px;
  }
`;

const ProjectAuthorsDisplay: FC<PropsT> = ({
  authors,
  editing,
  onAddClick,
  onRemoveClick,
  canRemoveUser,
  isProjectEdit,
  isAdminPage,
  isTeamMembers,
  isPresentation,
  flexible,
}) => {
  const isMobile = useIsMobile();
  const { t } = useTranslation();
  const isBookEditPage = !!useRouteMatch("/books/edit");

  const handleRemove = (data: AuthorT[], { action, removedValue } : AuthorActionsT) => {
    const confirmation = window.confirm(t('confirmation.user_delete'));

    if (!confirmation) return;

    const authors = data?.filter((author) => author?.designerId !== removedValue?.designerId)
    onRemoveClick && onRemoveClick(authors, { action, removedValue });
  }

  const showRemoveControl = canRemoveUser !== false;

  const designersList = useMemo(
    () => ((authors || []).map((author, index, arr) => {
      const computeAuthor = computeDesigner(author);
        return (
          <DesignerNameMob key={computeAuthor.designerId} widthMobile={'100%'} isProjectEdit={isProjectEdit} flexible={flexible}>
            {(isAdminPage || isPresentation) ? (
              <DesignerBorder isProjectEdit={isProjectEdit} isAdminPage={isAdminPage} align={"center"}>
                <FlexBox style={{ borderRadius: '1.5px'}} width={24} height={24} widthMobile={24} heightMobile={24} offsetRightMobile={8} offsetRight={8}>
                  <Avatar avatar={computeAuthor?.avatar} fs={24} rounded />
                </FlexBox>
                <FlexBox className={'text-wrapper'} align="center" justifyMobile='space-between' /*widthMobile={'calc(100% - 56px)'}*/ alignMobile={'center'}>
                  {`${computeAuthor.name} ${isTeamMembers ? computeAuthor.middleName : ''} ${computeAuthor.surName}`}
                </FlexBox>
                <FlexBox style={{ display: showRemoveControl ? 'flex' : 'none'}} className={'icon-wrapper'} offsetLeft={8} offsetLeftMobile={8} align='center' alignMobile='center'>
                  {!!handleRemove && <CloseIcon onClick={() => handleRemove( arr, { action: 'remove-value', removedValue: author })}/>}
                </FlexBox>
              </DesignerBorder>
            ) : (
              <>
                <DesignerBorder isProjectEdit={isProjectEdit}>
                  <FlexBox style={{ borderRadius: '1.5px'}} width={24} height={24} widthMobile={24} heightMobile={24} offsetRightMobile={8} offsetRight={8}>
                    <Avatar avatar={computeAuthor?.avatar} fs={24} rounded />
                  </FlexBox>
                  <FlexBox className={'text-wrapper'} justifyMobile='space-between' /*widthMobile={'calc(100% - 56px)'}*/ alignMobile={'center'}>
                    {`${computeAuthor.name} ${isTeamMembers ? computeAuthor.middleName : ''} ${computeAuthor.surName}`}
                  </FlexBox>

                <FlexBox offsetLeft={8}>
                {!!handleRemove && <BasketIcon fill={'#909090'} onClick={() => handleRemove( arr, { action: 'remove-value', removedValue: author })}/>}
                </FlexBox>
                </DesignerBorder>
                
              </>
            )}
          </DesignerNameMob>

        )
  })),
    [authors, isMobile, handleRemove, showRemoveControl],
  );

  return (
    <DesignersWrapper isBookEditPage={isBookEditPage}>
      {designersList}
    </DesignersWrapper>
  );
};

export default ProjectAuthorsDisplay;
